
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./bootstrap-navbar');
import store from './store/index.js'

// Translations

const messages = {
    en: {
        dispute: {
            info: 'Your general notes',
            mistake: 'Describe mistake',
            sn: 'Product SN',
            about: 'About',
            status: 'Status',
            created_at: 'Added at',
            solved_at: 'Solved at',
            product: {
                cause: 'Cause',
                order_code: 'Order code',
                wish: 'Customer wish',
                status: 'Status',
                pictures: 'Pictures',
                serial_number: 'Serial number',
                price_per_item: 'Price per item',
                price_without_tax: 'Price without VAT',
                price_with_tax: 'Price with VAT',
                customer_price: 'Price',
            }
        },
        order: {
            order_number: 'Order number',
            address: 'Address',
            date_ordered: 'Date ordered',
            estimated_delivery: 'Estimated delivery',
            price_with_tax: 'Price with tax',
            note: 'Note',
            status: 'Status',
            sum_weight: 'Sum weight',
            order_number: 'Order',
            paypal: 'Pay order with PayPal',
            card: 'Pay with credit card',
            delivery: 'Cash on delivery',
            customer: 'Title',
            vat: 'VAT',
            address: 'Address',
            contact_person: 'Contact person',
            email: 'Email',
            telephone: 'Telephone',
        },
        product: {
            order_code: 'Order code',
            serial_number: 'Serial number',
            quantity: 'Qty.',
            price_per_item: 'Price per item',
            price_without_tax: 'Price without tax',
            price_with_tax: 'Price with tax',
            customer_price: 'Customer price',
            order_note: 'Note',
        }
    },
    it: {
        dispute: {
            info: 'Your general notes',
            mistake: 'Describe mistake',
            sn: 'Product SN',
            about: 'About',
            status: 'Status',
            created_at: 'Added at',
            solved_at: 'Solved at',
            product: {
                cause: 'Cause',
                order_code: 'Order code',
                wish: 'Customer wish',
                status: 'Status',
                pictures: 'Pictures',
                serial_number: 'Serial number',
                price_per_item: 'Price per item',
                price_without_tax: 'Price without VAT',
                price_with_tax: 'Price with VAT',
                customer_price: 'Price',
            }
        },
        order: {
            order_number: 'Order number',
            address: 'Address',
            date_ordered: 'Date ordered',
            estimated_delivery: 'Estimated delivery',
            price_with_tax: 'Price with tax',
            note: 'Note',
            status: 'Status',
            sum_weight: 'Sum weight',
            order_number: 'Order',
            paypal: 'Paga con Paypal',
            card: 'Pagare con la carta di credito',
            delivery: 'Pagamento alla consegna',
            customer: 'Nome',
            vat: 'I.V.A.',
            address: 'Indirizzo',
            contact_person: 'Referente',
            email: 'Email',
            telephone: 'Telefono',
        },
        product: {
            order_code: 'Order code',
            serial_number: 'Serial number',
            quantity: 'Qty.',
            price_per_item: 'Price per item',
            price_without_tax: 'Price without tax',
            price_with_tax: 'Price with tax',
            customer_price: 'Customer price',
            order_note: 'Note',
        }
    },
    de: {
        dispute: {
            info: 'Your general notes',
            mistake: 'Describe mistake',
            sn: 'Product SN',
            about: 'About',
            status: 'Status',
            created_at: 'Added at',
            solved_at: 'Solved at',
            product: {
                cause: 'Cause',
                order_code: 'Order code',
                wish: 'Customer wish',
                status: 'Status',
                pictures: 'Pictures',
                serial_number: 'Serial number',
                price_per_item: 'Price per item',
                price_without_tax: 'Price without VAT',
                price_with_tax: 'Price with VAT',
                customer_price: 'Price',
            }
        },
        order: {
            order_number: 'Order number',
            address: 'Address',
            date_ordered: 'Date ordered',
            estimated_delivery: 'Estimated delivery',
            price_with_tax: 'Price with tax',
            note: 'Note',
            status: 'Status',
            sum_weight: 'Sum weight',
            order_number: 'Order',
            paypal: 'Mit PayPal bezahlen',
            card: 'Mit Kreditkarte bezahlen',
            delivery: 'Nachnahme',
            customer: 'Name',
            vat: 'MwSt',
            address: 'Adresse',
            contact_person: 'Gesprächspartner',
            email: 'Email',
            telephone: 'Telefon',
        },
        product: {
            order_code: 'Order code',
            serial_number: 'Serial number',
            quantity: 'Qty.',
            price_per_item: 'Price per item',
            price_without_tax: 'Price without tax',
            price_with_tax: 'Price with tax',
            customer_price: 'Customer price',
            order_note: 'Note',
        }
    },
    sl: {
        dispute: {
            info: 'Your general notes',
            mistake: 'Describe mistake',
            sn: 'Product SN',
            about: 'About',
            status: 'Status',
            created_at: 'Added at',
            solved_at: 'Solved at',
            product: {
                cause: 'Cause',
                order_code: 'Order code',
                wish: 'Customer wish',
                status: 'Status',
                pictures: 'Pictures',
                serial_number: 'Serial number',
                price_per_item: 'Price per item',
                price_without_tax: 'Price without VAT',
                price_with_tax: 'Price with VAT',
                customer_price: 'Price',
            }
        },
        order: {
            order_number: 'Order number',
            address: 'Address',
            date_ordered: 'Date ordered',
            estimated_delivery: 'Estimated delivery',
            price_with_tax: 'Price with tax',
            note: 'Note',
            status: 'Status',
            sum_weight: 'Sum weight',
            order_number: 'Order',
            paypal: 'Plačaj naročilo s PayPal',
            card: 'Plačaj s plačilno kartico',
            delivery: 'Plačilo po povzetju',
            customer: 'Naziv',
            vat: 'Davčna',
            address: 'Naslov',
            contact_person: 'Kontaktna oseba',
            email: 'Email',
            telephone: 'Telefon',
        },
        product: {
            order_code: 'Order code',
            serial_number: 'Serial number',
            quantity: 'Qty.',
            price_per_item: 'Price per item',
            price_without_tax: 'Price without tax',
            price_with_tax: 'Price with tax',
            customer_price: 'Customer price',
            order_note: 'Note',
        }
    }
}

window.Vue = require('vue');
import VueI18n from 'vue-i18n'
import { mapActions, mapMutations } from 'vuex'
import * as VueGoogleMaps from "vue2-google-maps";

/**
 * TODO: use Vue router too, se splacha overhead?
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

window.Vue.use(VueI18n)

Vue.component('product-list', require('./components/ProductList.vue').default);
Vue.component('product-index', require('./components/ProductIndex.vue').default);
Vue.component('product-settings', require('./components/ProductSettings.vue').default);
Vue.component('image-gallery', require('./components/ImageGallery.vue').default);
Vue.component('item-cart', require('./components/Cart.vue').default);
Vue.component('dealers-map', require('./components/DealersMap.vue').default);
Vue.component('pop-up', require('./components/PopUp.vue').default);
Vue.component('cookie-bar', require('./components/CookieBar.vue').default);

// Order pages
Vue.component('order-steps', require('./components/OrderSteps.vue').default);
Vue.component('address-editor', require('./components/AddressEditor.vue').default);
Vue.component('order-summary', require('./components/OrderSummary.vue').default);
Vue.component('order-list', require('./components/OrderList.vue').default);
// TODO: Use order-show for order procedure, add configs and variable editing
Vue.component('order-show', require('./components/orders/Show.vue').default);
// TODO: Order product row for order procedure
Vue.component('order-product-row', require('./components/orders/ProductRow.vue').default);

// Disputes
Vue.component('create-dispute', require('./components/disputes/Create.vue').default);
Vue.component('show-dispute', require('./components/disputes/Show.vue').default);

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDaeUkeMB2yHTWk2yr5ECYuwjQnKXchdNs",
        libraries: "places" // necessary for places input
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const i18n = new VueI18n({
    locale: 'en', // set locale
    messages, // set locale messages
})
/**
 * The cart variable is an array of Item objects:
 *
 * Use localstorage for cart until user doesn't open cart view
 */
const app = new Vue({
    i18n,
    store,
    el: '#app',
    data() {
        return {
            orderStep: 1,
            address: {
                title: '',
                address: '',
                vat: '',
                telephone: '',
                email: '',
                contact_person: '',
            },
            order: {},
        }
    },
    computed: {
    },
    created() {
        this.getCart().then((response) => {
            this.UPDATE_CART(response.data.items);
        });

    },
    methods: {
        ...mapActions(['getCart']),
        ...mapMutations(['UPDATE_CART']),
        setStep(i){
            this.orderStep = i;
        },
        setOrder(order){
            this.order = order;
        },
    },
});
